const planCoversOOA = plan => {
    const coverage = plan.areaCoverage;
    if (plan.platform && plan.platform.toUpperCase() === "PRIME") {
        return coverage === "Out" || coverage === "All";
    } else {
        return coverage === "Out - Live and Travel" || coverage === "Out - Travel";
    }
}

export default planCoversOOA;